// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"f1ff5ac5","95":"6f0b4e1b","224":"11990683","227":"f8369985","281":"e3184858","325":"71589f4f","511":"b47b966a","579":"380ff03c","627":"1fb8bda7","681":"7ced4fd9","745":"b2a4a2e5","797":"4ca2720b","859":"3cf1d0cb","921":"b4b0740b","923":"c581f5fd"}[chunkId] + ".chunk.css";
};